import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const EditUser = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isAddUser = location.pathname === "/manage-users/add";
  const user = location?.state?.user || {};

  // FORM STATES
  const [fullName, setFullName] = React.useState(user?.name || "");
  const [email, setEmail] = React.useState(user?.email || "");
  const [phone, setPhone] = React.useState(user?.phone || "");
  const [subscription, setSubscription] = React.useState(user?.subscription || "Monthly");
  const [status, setStatus] = React.useState(user?.status || "Active");
  const [address, setAddress] = React.useState(user?.address || "");

  const handleSubmit = () => {
    const payload = {
      fullName,
      email,
      phone,
      subscription,
      status,
      address,
    };
    console.log("Form Submitted:", payload);

    navigate("/manage-users");
  };

  return (
    <>
      <div className="main_title">
        <h1>{isAddUser ? "Add" : "Edit"} User</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-users")}> Manage Users</button> -
          {isAddUser ? "Add" : "Edit"} User
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">

            {/* FULL NAME */}
            <div className="control_group w_33">
              <label>Full Name</label>
              <TextField
                placeholder="Name"
                fullWidth
                hiddenLabel
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            {/* EMAIL */}
            <div className="control_group w_33">
              <label>Email</label>
              <TextField
                type="email"
                placeholder="Email"
                fullWidth
                hiddenLabel
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* PHONE */}
            <div className="control_group w_33">
              <label>Phone Number</label>
              <PhoneInput
                country={"in"}
                value={phone}
                onChange={(value) => setPhone(value)}
                placeholder="Enter Phone Number"
                inputStyle={{ width: "100%" }}
              />
            </div>

          

            {/* SUBSCRIPTION PLAN */}
            <div className="control_group w_33">
              <label>Subscription Plan</label>
              <Select
                fullWidth
                value={subscription}
                onChange={(e) => setSubscription(e.target.value)}
                hiddenLabel
              >
                <MenuItem value={"Monthly"}>Monthly</MenuItem>
                <MenuItem value={"Quarterly"}>Quarterly</MenuItem>
                <MenuItem value={"Yearly"}>Yearly</MenuItem>
              </Select>
            </div>

            {/* STATUS */}
            <div className="control_group w_33">
              <label>Status</label>
              <Select
                fullWidth
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                hiddenLabel
              >
                <MenuItem value={"Active"}>Active</MenuItem>
                <MenuItem value={"Inactive"}>Inactive</MenuItem>
              </Select>
            </div>

            {/* ADDRESS */}
            <div className="control_group w_33">
              <label>Address</label>
              <TextField
                placeholder="Address"
                fullWidth
                hiddenLabel
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

          </div>

          {/* SAVE BUTTON */}
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
